import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultManagersPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultManagersFilter = {
	$skip: defaultManagersPagination.$skip,
	$limit: defaultManagersPagination.$limit,
	roleType: '',
};

export default {
	namespaced: true,
	state: {
		managers: [],
		managersFilter: defaultManagersFilter,
		managersPagination: defaultManagersPagination,
		managerTrustRoles: [],
	},
	getters: {
		managers: (state) => state.managers,
		managersPage: (state) => {
			const { $limit, $skip } = state.managersPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_MANAGERS: (state, managers) => {
			state.managers = managers;
		},
		SET_MANAGERS_FILTER: (state, filter) => {
			state.managersFilter = { ...state.managersFilter, ...filter };
		},
		SET_DEFAULT_MANAGERS_FILTER: (state, filter) => {
			state.managersFilter = { ...filter, ...defaultManagersFilter };
		},
		SET_MANAGERS_PAGINATION: (state, data) => {
			state.managersPagination = { ...state.managersPagination, ...data };
		},
		SET_MANAGER_TRUST_ROLES: (state, data) => { state.managerTrustRoles = data; },
	},
	actions: {
		setManagersFilter: ({ commit }, filter) => {
			commit('SET_MANAGERS_FILTER', filter);
		},
		setDefaultManagersFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_MANAGERS_FILTER', filter);
		},
		setManagersPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.managersPagination.$limit;
			commit('SET_MANAGERS_PAGINATION', { $skip });
			commit('SET_MANAGERS_FILTER', { $skip });
		},
		loadManagers: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/managers';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filter } });
			commit('SET_MANAGERS', results.data);
			const totalCount = results.total;
			commit('SET_MANAGERS_PAGINATION', { total: totalCount });
			return results;
		},
		loadCareLocations: async ({ rootGetters }) => {
			const url = '/api/v3/care-locations';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false } });
			return results;
		},
		createNewManager: async ({ rootGetters }, data) => {
			const url = '/api/v3/managers';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		getTrustById: async (context, id) => {
			const url = '/api/v3/trusts';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		resendInvitationMail: async (context, req) => {
			const url = '/api/v3/authmanagement';
			const results = await feathersClient.service(url).create(req);
			return results;
		},
		getManagerRolesForTrust: async ({ rootGetters, commit }, filter) => {
			let results = await feathersClient.service('/api/v3/trust-roles').find({
				query: {
					$role: rootGetters.currentUserRole,
					fields: ['role'],
					$paginate: false,
					isActive: true,
					...filter,

				},
			});
			// console.log('managerRoles', results);
			if (results && results.length > 0) {
				results = results?.filter((item) => item.role.roleLevel === 'MANAGER');
			} else {
				results = [];
			}
			commit('SET_MANAGER_TRUST_ROLES', results);
			return results;
		},
	},
};
